import { render } from "./GalleryHeader.vue?vue&type=template&id=b3b4413a&scoped=true"
import script from "./GalleryHeader.vue?vue&type=script&lang=js"
export * from "./GalleryHeader.vue?vue&type=script&lang=js"

import "./GalleryHeader.vue?vue&type=style&index=0&id=b3b4413a&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3b4413a"]])

export default __exports__